import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Patients Say
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Real stories from real people who trusted us with their smiles
          </p>
          
          {/* Prominent Rating Summary */}
          <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-8 max-w-4xl mx-auto text-white shadow-2xl">
            <div className="grid md:grid-cols-3 gap-6 items-center">
              <div className="text-center md:border-r border-white/30">
                <div className="text-6xl font-bold mb-2">5.0</div>
                <div className="flex justify-center mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={24} fill="#fbbf24" stroke="#fbbf24" />
                  ))}
                </div>
                <div className="text-emerald-100">Average Rating</div>
              </div>
              <div className="text-center md:border-r border-white/30">
                <div className="text-6xl font-bold mb-2">500+</div>
                <div className="text-emerald-100 text-lg">Total Reviews</div>
                <div className="text-sm text-emerald-200 mt-1">Verified Patients</div>
              </div>
              <div className="text-center">
                <div className="text-6xl font-bold mb-2">100%</div>
                <div className="text-emerald-100 text-lg">5-Star Reviews</div>
                <div className="text-sm text-emerald-200 mt-1">Patient Satisfaction</div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="border-2 hover:border-emerald-200 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <CardContent className="pt-6">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={18} fill="#fbbf24" stroke="#fbbf24" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="border-t pt-4">
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <div className="flex items-center gap-1 text-sm text-gray-600 mt-1">
                    <MapPin size={14} />
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* More Reviews Note */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg mb-4">
            Showing 40 of 500+ verified patient reviews. All reviews are from real patients who visited our clinic.
          </p>
          <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-6 max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-3">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={32} fill="#fbbf24" stroke="#fbbf24" />
                ))}
              </div>
              <span className="text-4xl font-bold text-emerald-700">5.0</span>
            </div>
            <p className="text-lg font-semibold text-gray-800 mb-2">Based on 500+ Google Reviews</p>
            <p className="text-gray-600">Join hundreds of satisfied patients from Balapur and surrounding areas</p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-20 bg-gradient-to-r from-emerald-600 to-teal-600 rounded-2xl p-12 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">5,000+</div>
              <div className="text-emerald-100 text-lg">Happy Patients</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">15+</div>
              <div className="text-emerald-100 text-lg">Years Experience</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">500+</div>
              <div className="text-emerald-100 text-lg">5-Star Reviews</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">5.0</div>
              <div className="text-emerald-100 text-lg">Average Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
